import React from "react";

export default function StepCompliance({ data, errors = {}, onChange, onBack, onNext }) {
  return (
    <div className="add-form">
      {/* Level 2 cert */}
      <label>
        <select
          value={data.has_level2 ? "yes" : "no"}
          onChange={(e) => onChange({ has_level2: e.target.value === "yes" })}
          className={errors.has_level2 ? "invalid" : ""}
        >
          <option value="no">Level 2 Food Hygiene certificate? No</option>
          <option value="yes">Level 2 Food Hygiene certificate? Yes</option>
        </select>
      </label>

      {/* Allergen process */}
      <label>
        <input
          placeholder="Describe your allergen process"
          value={data.allergen_process || ""}
          onChange={(e) => onChange({ allergen_process: e.target.value })}
          className={errors.allergen_process ? "invalid" : ""}
        />
      </label>

      {/* Insurance */}
      <label>
        <input
          placeholder="Insurance policy number"
          value={data.insurance_policy || ""}
          onChange={(e) => onChange({ insurance_policy: e.target.value })}
          className={errors.insurance_policy ? "invalid" : ""}
        />
      </label>

      <div className="actions">
        <button className="btn ghost" onClick={onBack}>Back</button>
        <button className="btn" onClick={onNext}>Next</button>
      </div>
    </div>
  );
}

